import React from 'react';
import { ReactSVG } from 'react-svg';
//import styled from 'styled-components';
import styled from '@emotion/styled';

interface IPropsButton {
    filled?: boolean;
    active?: boolean;
    text: string;
    onClick?: () => void;
    height?: number;
    width?: number;
}

const Button: React.FC<IPropsButton> = ({ active = true, filled = false, text, onClick, height = 24, width = 100 }) => {
    if (active) {
        if (filled)
            return (
                <ButtFilled width={width} height={height} onClick={onClick}>
                    <Text>{text}</Text>
                </ButtFilled>
            );
        else
            return (
                <ButtNoFilled width={width} height={height} onClick={onClick}>
                    <Text>{text}</Text>
                </ButtNoFilled>
            );
    } else {
        return (
            <ButtonNoActive width={width} height={height}>
                <Text>{text}</Text>
            </ButtonNoActive>
        );
    }
};

export default Button;

const ButtonNoActive = styled.div<{ width: number; height: number }>`
    cursor: pointer;
    background: #ffffff;
    border-radius: 5px;
    border: 1px solid #66c3d0;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    height: ${(props) => props.height}px;
    min-height: ${(props) => (props.height - 2) / 10}px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: max-content;
    min-width: ${(props) => (props.width - 30) / 10}em;
    padding: 0 1em;
    user-select: none;
`;
const ButtNoFilled = styled(ButtonNoActive)`
    & > div {
        color: #92d8e1;
    }
    &:hover {
        background: #66c3d0;
    }
    &:hover > div {
        color: #ffffff;
    }
    &:active {
        background: #61b8c5;
        border-color: #61b8c5;
    }
    &:active > div {
        color: #ffffff;
    }
`;
const ButtFilled = styled(ButtNoFilled)`
    background: #92d8e1;
    & > div {
        color: #ffffff;
    }
`;

export const ButtonIcon: React.FC<{ onClick?: () => void; src: string; active?: boolean; title?: string }> = ({
    onClick,
    src,
    active,
    title
}) => {
    return (
        <ButtonIconStyle active={active} onClick={onClick} title={title}>
            <ReactSVG src={src} />
        </ButtonIconStyle>
    );
};

// const ButtonIconStyle = styled.div<{ active?: boolean }>`
//     cursor:pointer!important;
//     padding: 1em;
//     & *{
//         fill:${props => (props.active) ? '#66C3D0!important;' : '#AEAEAE!important;'};
//     }
//     &:hover  *{
//         fill:#66C3D0 !important;

//     }
// `

const ButtonIconStyle = styled.div<{ active?: any }>`
    cursor: pointer !important;
    padding: 2.5px;
    &:hover * {
        fill: #66c3d0 !important;
    }
`;

// const ButtFilled = styled(ButtonNoActive)`
//     border: 1px solid #A4DEE7;
//     box-shadow: 4px 4px 6px rgba(0, 0, 0, 0.05);
//     &:hover {
//         background: #8ED5DF;
//         box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.14);
//     }
//     &:hover > div {
//         color: #FFFFFF;
//     }
//     &:active{
//         background: #66C3D0;
//         box-shadow: 4px 4px 6px rgba(0, 0, 0, 0.1);
//     }
//     & > div{ color: #66C3D0; }
// `
const Text = styled.div`
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #a6a6a6;
`;
